import { ExternalRegistrationLinkModel } from './models/external_registration_link_model';
class ExternalRegistrationLinkController {
  private externalRegistrationLinkUrl?: string;
  constructor(private ngExternalRegistrationLinkModel: ExternalRegistrationLinkModel) {}
  $onChanges() {
    this.externalRegistrationLinkUrl = this.ngExternalRegistrationLinkModel.read().text;
  }
}

angular.module('capability-ng-academic-planner').component('externalRegistrationLink', {
  controller: ExternalRegistrationLinkController,
  templateUrl:
    'capability-ng-academic-planner/src/advisor_header/components/external_registration_link/external_registration_link.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/external_registration_link/external_registration_link.ts